import Vue from "vue";
import "./quasar";
import ProductDownloads from "@/components/ProductDownloads.vue";
import ProductSelector from "@/components/ProductSelector/ProductSelector.vue";
import store from "./store/store";
Vue.config.productionTip = false;

export const bus = new Vue();

const productSelectorEl = document.getElementById(
  "app-product-selector"
) as HTMLElement;
if (productSelectorEl) {
  new Vue({
    store: store.original,
    render: h =>
      h(ProductSelector, {
        props: {
          queryUrl: productSelectorEl.dataset.queryurl,
          language: productSelectorEl.dataset.language
        }
      })
  }).$mount(productSelectorEl);
}

const productDownloadsEl = document.getElementById(
  "app-product-downloads"
) as HTMLElement;
if (productDownloadsEl) {
  new Vue({
    store: store.original,
    render: h => h(ProductDownloads, {
      props: {
        language: productDownloadsEl.dataset.language
      }
    })
  }).$mount(productDownloadsEl);
}
